import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { isAuthenticated } from '../store/selectors';
import { State } from '../typings';

@Injectable()
export class LoginGuard implements CanActivate, CanLoad {
  constructor(
    private store: Store<State>,
    private router: Router,
    private auth: AuthService,
  ) {
    this.auth.isAuthenticated();
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.isNotAuthenticated();
  }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return this.isNotAuthenticated();
  }

  private isNotAuthenticated() {
    return this.store.pipe(
      select(isAuthenticated),
      map((authenticated) => {
        if (authenticated) {
          this.router.navigateByUrl('/');
        }
        return !authenticated;
      }),
    );
  }
}
